(function (Sliders, $, undefined) {

  var $window = $(window),
      nostoDone = false;
      nostoSliders = [],
      blockArrow = {
          'prev': {
              'reg': '<button type="button" class="arrow-block prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
              'small': '<button type="button" class="arrow-block prev small"><i class="fa fa-angle-left" aria-hidden="true"></i></button>'
          },
          'next': {
              'reg': '<button type="button" class="arrow-block next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
              'small': '<button type="button" class="arrow-block next small"><i class="fa fa-angle-right" aria-hidden="true"></i></button>'
          }
      },
      simpleArrow = {
          'prev': {
              'reg': '<button type="button" class="arrow-simple prev"></button>'
          },
          'next': {
              'reg': '<button type="button" class="arrow-simple next"></button>'
          }
      };

  Sliders.waitForNosto = function(){
    if(typeof nostojs !== 'undefined') {
      nostojs(function(api){
        api.listen("postrender", function(nostoPostRenderEvent) {
          if($('[data-nosto-recommend]').length === 0) {
            Reviews.build();
          } else {
            Sliders.nostoLoad();
          }
        });
      });
    } else {
      window.setTimeout(function(){
        Sliders.waitForNosto();
      },750);
    }
  };

  var getSlides = function(products,index,$el,html) {
    if (index < products.length) {
      var arr = products[index].split('/'),
          handle = arr[arr.length - 1].split('?')[0];

      $.get('/products/' + handle + '?view=grid-item').done(function(data){
        if (handle !== '') {
          html+=data;
        }
        index++;
        getSlides(products,index,$el,html);
      });
    } else {
      buildSlider($el,html);
    }
  };

  var buildSlider = function($el, html) {
    $el.html(html);
    Reviews.build();
    if(!$el.is(':visible')) {
      $el.parents('.shopify-section').show();
      $el.parent().show();
    }

    if(!$el.hasClass('slick-slider')) {
      $el.slick(getSliderSettings($el));
    }
  };

  Sliders.nostoLoad = function(){
    for(var i = 0; i < $('[data-nosto-recommend]').length; i++) {
      var $curr = $('[data-nosto-recommend]').eq(i),
          $el = $curr.parents('.dynamic_block').length == 0 ? $curr : $curr.parents('.dynamic_block').find('.js-slider'),
          html = '',
          products = $curr.data('nosto-recommend').split(',');

      getSlides(products,0,$el,html);
    }
  };

  var getSliderSettings = function($el){

    var slickSettings = {},
        slides = $el.data('maxslides'),
        navType = $el.data('nav'),
        variableWidth = $el.data('variable'),
        autoplay = $el.data('autoplay'),
        autoplaySpeed = parseInt($el.data('autoplay-speed'));

    slickSettings.slidesToShow = slides;
    slickSettings.variableWidth = false;

    slickSettings.autoplay = autoplay;
    slickSettings.autoplaySpeed = autoplaySpeed;

    if(navType == 'dots') {
      slickSettings.dots = true;
      slickSettings.appendDots = $el.parent();
      slickSettings.arrows = false;
      slickSettings.dotsClass = 'slick-dots home-slider-dots';
    } else if (navType == 'arrows') {
      slickSettings.arrows = true;
      slickSettings.prevArrow = blockArrow.prev.reg;
      slickSettings.nextArrow = blockArrow.next.reg;
    }

    if(slides > 1) {
      slickSettings.responsive = [
        {
          breakpoint: 980,
          settings: {
            'slidesToShow': 3
          }
        },
        {
          breakpoint: 640,
          settings: {
            'slidesToShow': 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            'variableWidth': variableWidth,
            'slidesToShow': 1
          }
        }
      ];
    }
    return slickSettings;
  };

  var loadSliders = function () {
    for (var i = 0; i < $('.js-slider').length; i++) {
      var $curr = $('.js-slider').eq(i);

      if($curr.parents('.dynamic_block').length && $curr.parents('.dynamic_block').find('.nosto_element').length) {
        nostoSliders.push($curr);
        $curr.parents('.shopify-section').hide();
      } else {
        $curr.parents('.shopify-section').show();
        if(!$curr.hasClass('slick-slider')) {
          $curr.slick(getSliderSettings($curr));
        } else {
          console.log('slider already init');
        }
      }
    }
  }


  var bindUIActions = function () {
    $('.js-slideshow-main').slick({
        'prevArrow': blockArrow.prev.small,
        'nextArrow': blockArrow.next.small,
        'asNavFor': '.js-slideshow-desc'
    });

    $('.js-slideshow-nav').slick({
        'prevArrow': simpleArrow.prev.reg,
        'nextArrow': simpleArrow.next.reg,
        'variableWidth': true,
        'focusOnSelect': true,
        'slidesToShow': 10,
        'slidesToScroll': 10
    });

    $('.slideshow-nav-single').on('click', function() {
        var curr = parseInt($(this).attr('data-slick-index'));
        $('.js-slideshow-desc').slick('slickGoTo', curr, true);
        $(this).addClass('is-active').siblings().removeClass('is-active');
    });

    $('.js-slideshow-desc').slick({
        'arrows': false,
        'adaptiveHeight': false,
        'asNavFor': '.js-slideshow-main',
        responsive: [{
            breakpoint: 991,
            settings: {
                'adaptiveHeight': true
            }
        }]
    }).on('afterChange', function(slick, currentSlide) {
        var curr = currentSlide.currentSlide;
        $('.js-paginate-slideshow').text(curr + 1);
        $('.js-slideshow-nav').slick('slickGoTo', curr, false);
        $('.js-slideshow-nav [data-slick-index=' + curr + ']').addClass('is-active').siblings().removeClass('is-active');
    });
  };

  Sliders.init = function () {
    loadSliders();
    bindUIActions();
    Sliders.waitForNosto();
  };

}(window.Sliders = window.Sliders || {}, jQuery));
